import {getCookie, removeCookie} from "react-use-cookie";
import axios from "axios";

import {ERROR, findIfTokenExpired} from "../utilities/generalConstants.js/generalConstants";

import {apiUrl} from "./baseURL";

let navigateFunction = () => {};

export const setNavigateFunction = navigateFn => {
  navigateFunction = navigateFn;
};

export const instance = axios.create({
  baseURL: apiUrl,
  // headers: {
  //   Authorization: `Bearer ${token || ""}`,
  // },
});

instance.interceptors.request.use(
  config => {
    const token = getCookie("access_token");
    const isTokenExpired = findIfTokenExpired();

    const isNotLoginRequest = config.url !== "/auth/login" && config.url !== "/users/changePass";
    const from = window.location.pathname;

    if (isNotLoginRequest && (!token || isTokenExpired)) {
      from !== "/login" && navigateFunction("/login", {state: {from}});
      removeCookie("access_token");
      localStorage.removeItem("login_time");
      return Promise.reject(ERROR.TOKEN);
    }

    config.headers["Authorization"] = `Bearer ${token}` || "";
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
